import { AccountService } from './../services/account.service';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RolesEnum } from '../enums/roles.enum';
import { Account } from '../interfaces/profile.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private accountService: AccountService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkAndRedirect();
  }
  canLoad(): Observable<boolean> {
    return this.checkAndRedirect();
  }
  private checkAndRedirect(): any {
    const account: Account = this.accountService.getAccount();
    if (account.role === RolesEnum.admin) {
      return true;
    } else if (account.role === RolesEnum.instructor) {
      return this.router.navigate(['instructor']);
    } else {
      return this.router.navigate(['participant']);
    }
  }
}
